import { Visibility, VisibilityOff } from '@mui/icons-material';
import { InputAdornment, IconButton, type TextFieldProps } from '@mui/material';
import { useState } from 'react';

import { StyledTextField } from './FormField.js';

type PasswordFieldProps = Omit<TextFieldProps, 'type'> & {
  readonly label: string;
  readonly placeholder: string;
};

const PasswordField = ({ label, placeholder, ...props }: PasswordFieldProps) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <StyledTextField
      {...props}
      fullWidth
      required
      size="small"
      label={label}
      type={showPassword ? 'text' : 'password'}
      slotProps={{
        inputLabel: { shrink: true },
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                edge="end"
                size="small"
                onClick={() => {
                  setShowPassword((previous) => !previous);
                }}
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
      placeholder={placeholder}
    />
  );
};

export default PasswordField;
